module.exports = __webpack_public_path__ + "img/166.5bb8d1df.jpg";